import { gql } from '@apollo/client'

export const GET_LUGGAGE_MASTER_PLAN = gql`
    query searchLuggage($id: String, $search_string: String, $status_code: Boolean, $page: PageInput!) {
        searchLuggage(id: $id, search_string: $search_string, status_code: $status_code, page: $page) {
            code
            success
            message
            luggages {
              luggage_id
              weight
              dimensions {
                length
                width
                height
              }
              price {
                base
              }
              active
              metadata {
                luggage_type
                seat_type
                piece_count
                category
              }
            }
        }
    }
`
